<div class="featured-products-row-container" [ngClass]="cardRowClass" *ngIf="!!products && products.length > 0">
    <h2 class="featured-products-row-title heading-3"><span>{{translatedTitle}}</span></h2>
    <product-card-carousel [products]="products" [shareOptions]="shareOptions" [cardRowClass]="cardRowClass"></product-card-carousel>
    <div *ngIf="showAiMessage" class="featured-products-row-ai-desc" translate="cart.featured.products.ai.desc"></div>
</div>
